// extracted by mini-css-extract-plugin
export var imageText = "survey-option-image-text-module--image-text--mwBaa";
export var imageTextIcon = "survey-option-image-text-module--image-text-icon--DDtV8";
export var imageTextInput = "survey-option-image-text-module--image-text-input--JPzmE";
export var imageTextOption = "survey-option-image-text-module--image-text-option--bGOl0";
export var labelText = "survey-option-image-text-module--label-text--17sMM";